// Shared Handlebars `{{token}}` detection. Extracted from
// HandlebarsInstructionsEditor so the agent Test modal can surface the same
// variables the editor highlights (one input per detected token).

/**
 * Matches a Handlebars reference like `{{deviceId}}` or `{{ user.name }}`.
 * Captures the bare token name (group 1). Intentionally simple: no helpers,
 * blocks, or `{{#each}}` — agent instructions use plain interpolation.
 *
 * `g` flag, so callers that iterate with `matchAll` get every occurrence;
 * for `.test()` callers, build a fresh non-global RegExp instead to avoid
 * `lastIndex` statefulness.
 */
export const handlebarsTokenRe = /\{\{\s*([a-zA-Z_$][\w.$]*)\s*\}\}/g;

/**
 * Return the UNIQUE token names referenced in `text`, in first-seen order.
 * Drives the Test modal's variable inputs.
 */
export function parseHandlebarsTokens(text: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const m of text.matchAll(handlebarsTokenRe)) {
    const name = m[1];
    if (!name || seen.has(name)) continue;
    seen.add(name);
    out.push(name);
  }
  return out;
}
